import * as React from "react";
const defaultAppointmentFormContextValues = {
  Form: void 0
};
const appointmentFormContext = React.createContext(
  defaultAppointmentFormContextValues
);
const useAppointmentForm = () => {
  const context = React.useContext(appointmentFormContext);
  if (context === defaultAppointmentFormContextValues) {
    throw new Error(
      "No AppointmentFormContextProvider available. You might still need to wrap the application with the appointment form context Provider."
    );
  }
  return context;
};
const AppointmentFormContextProvider = ({
  Form,
  children
}) => {
  const { Provider } = appointmentFormContext;
  const value = React.useMemo(
    () => ({
      Form
    }),
    [Form]
  );
  return /* @__PURE__ */ React.createElement(Provider, { value }, children);
};
appointmentFormContext.displayName = "AppointmentFormContext";
appointmentFormContext.Consumer;
export {
  AppointmentFormContextProvider,
  appointmentFormContext,
  useAppointmentForm
};
//# sourceMappingURL=AppointmentFormContext.js.map
